import { useAuth } from '../context/AuthContext';
import { useAWSCredentials } from './AWSConnect';
import { useAzureCredentials } from './AzureConnect';
import { useGCPCredentials } from './GCPConnect';

/**
 * Hook to determine if the current user should see data.
 * Returns true if user has connected cloud providers OR is the demo account.
 */
export const useDemoData = () => {
  const { user } = useAuth();
  const { isConnected: awsConnected } = useAWSCredentials();
  const { isConnected: azureConnected } = useAzureCredentials();
  const { isConnected: gcpConnected } = useGCPCredentials();

  const isDemoUser = user?.email === 'demo@cartieai.com';
  const hasCloudConnection = awsConnected || azureConnected || gcpConnected;
  const shouldShowData = isDemoUser || hasCloudConnection;

  return { isDemoUser, hasCloudConnection, shouldShowData };
};
